const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g,
  (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[character]);
const amount = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;
const money = (value) => amount(value).toLocaleString();

export const buildOrderTransferQRCode = ({ account, bank, total, storeName }) => {
  const base = (process.env.REACT_APP_SEPAY_QR_BASE_URL || "https://qr.sepay.vn").replace(/\/+$/, "");
  const query = new URLSearchParams({
    acc: account || "", template: "qronly", bank: bank || "",
    amount: String(amount(total)), des: `Thanh toan hoa don tai ${storeName || ""}`,
  });
  return `${base}/img?${query}`;
};

// Use the saved bill snapshot, including free lines, for the printed item table.
export const buildOrderReceiptRows = (items) => items.map((item) => {
  const price = amount(item.unitPrice);
  const quantity = amount(item.quantity);
  const originalTotal = price * quantity;
  const discount = Math.max(0, Math.min(100, amount(item.KmaiPT)));
  const isGift = discount === 100 && Number(item.MXTY) === 2;
  const lineTotal = isGift ? 0 : item.ThanhTien !== undefined
    ? amount(item.ThanhTien) : originalTotal * (1 - discount / 100);
  const lineTotalHtml = lineTotal < originalTotal
    ? `<del>${money(originalTotal)}</del><br/><strong>${money(lineTotal)}</strong>` : money(lineTotal);
  return `<tr${isGift ? ' data-receipt-gift="true"' : ""}>
    <td>${escapeHtml(item.name)}${isGift ? '<br/><strong>Tặng kèm · 0₫</strong>' : ""}</td>
    <td>${quantity}</td>
    <td>${isGift ? `<del>${money(price)}</del><br/>0` : money(price)}</td>
    <td>${lineTotalHtml}</td>
  </tr>`;
}).join("");

export const buildOrderReceiptQR = (qrCode, total) => qrCode ? `
  <hr/>
  <div data-receipt-payment-qr="true" style="text-align:center; break-inside:avoid; margin:8px 0;">
    <strong>Quét mã QR để chuyển khoản</strong>
    <img src="${escapeHtml(qrCode)}" alt="QR thanh toán chuyển khoản" width="144" height="144"
      style="display:block; width:38mm; height:38mm; object-fit:contain; margin:6px auto;" />
    <div>Số tiền: <strong>${money(total)}₫</strong></div>
  </div>
` : "";
